import React from 'react'

const BenefitCard = ({ icon, title, description }) => {
  return (
    <div className='bg-transparent rounded-md border-2 border-border p-6 flex flex-col h-full'>
      {/* Mobile layout (centered) */}
      <div className='md:hidden flex flex-col items-center text-center'>
        <img src={icon} alt={title} className='w-16 h-16 mb-4' />
        <h3 className='text-lg font-bold text-text-primary mb-3'>{title}</h3>
        <p className='text-text-secondary text-sm'>{description}</p>
      </div>

      {/* Desktop layout (icon on left) */}
      <div className='hidden md:flex items-start'>
        <img src={icon} alt={title} className='w-12 h-12 mr-4 flex-shrink-0' />
        <div>
          <h3 className='text-lg font-bold text-text-primary mb-2'>{title}</h3>
          <p className='text-text-secondary text-sm'>{description}</p>
        </div>
      </div>
    </div>
  )
}

export default BenefitCard
